import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { getOssConfig } from '@/api/system/upload.js'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { guid } from '@/utils/ruoyi.js'

export default class UploadFileToOSS {
    /**
     * [constructor description]
     * @param  {[Array]} files [chooseImg选中的tempFilePaths、chooseVideo选中的rempFilePath]
     * @param  {[Object]} json  [success每上传成功一张调用 complete全部上传完成调用]
     * @return {[void]}       [description]
     */

    constructor(files, json) {
        if (!Array.isArray(files)) {
            throw new Error('Class UploadFileToOSS parameter must be an array')
        }
        console.log('files, json', files, json)
        this.data = []
        this.fn = json.success
        this.complete = json.finally
        this.files = files
        this.fileLen = this.files.length
        this.curIndex = 0
        // notification.info({ message: '上传中' })
        this.upload()
    }

    async upload() {
        const token = storage.get(ACCESS_TOKEN)
        // 随机生成一个文件名，并且按照日期归类到二级目录下，否则很容易产生覆盖
        const dates = new Date()
        const year = dates.getFullYear()
        const month = dates.getMonth() + 1
        const date = dates.getDate()
        const bmonth = month < 10 ? `0${month}` : month
        const bdate = date < 10 ? `0${date}` : date
        // 签名按该目录限制直传 key 前缀，避免凭证被挪用于覆盖桶内其它文件
        const dir = `${year}/${bmonth}/${bdate}/`
        getOssConfig(dir).then(res => {
            const ossData = res.data
            const form = new FormData()
            const name = this.resolveFileExtension(this.files[0])
            form.append('key', dir + ossData.fileName + '.' + name)
            form.append('policy', ossData.policy)
            form.append('OSSAccessKeyId', ossData.accessid)
            form.append('success_action_status', '200')
            form.append('signature', ossData.signature)
            form.append('file', this.files[0])
            axios({
                // 必须 POST 到 bucket 直连域名（uploadUrl），不能发到 resultUrl（CDN 域名）：
                // CDN 对 POST 会返回 200 但文件并未真正写入 OSS，导致"上传成功却显示不出来"
                url: ossData.uploadUrl,
                method: 'post',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                    'Content-Disposition': 'attachment;filename=' + encodeURIComponent(ossData.fileName)
                },
                data: form
            }).then(res => {
                console.log('res', res)
                if (res.status === 200) {
                    const url = ossData.resultUrl + '/' + dir + ossData.fileName + '.' + name
                    this.data.push({
                        uid: guid(8, 10),
                        status: 'done',
                        name: ossData.fileName + '.' + name,
                        halfUrl: dir + ossData.fileName + '.' + name,
                        path: url,
                        url: url,
                        cover: ''
                    })
                    if (this.fn) this.fn(this.data)
                } else {
                    notification.error('上传失败，请重试')
                }
            }).finally(res => {
                console.log('结束', res)
                if (this.fn) this.fn(this.data)
                this.curIndex++ // 当前文件执行完上传后，开始上传下一张
                if (this.curIndex === this.fileLen) { // 当文件传完时，停止调用
                    this.complete(this.data)
                } else { // 若文件还没有传完，则继续调用函数
                    this.upload()
                }
            })
        })
    }

    resolveFileExtension(file) {
        const mimeType = file && file.type ? String(file.type).toLowerCase() : ''
        if (mimeType.indexOf('/') > -1) {
            return mimeType.split('/')[1]
        }
        const fileName = file && file.name ? String(file.name) : ''
        const index = fileName.lastIndexOf('.')
        if (index > -1 && index < fileName.length - 1) {
            return fileName.substring(index + 1).toLowerCase()
        }
        return 'bin'
    }
}
